import { render } from "./ReadyToPickupIcon.vue?vue&type=template&id=996b4048"
import script from "./ReadyToPickupIcon.vue?vue&type=script&lang=js"
export * from "./ReadyToPickupIcon.vue?vue&type=script&lang=js"

import exportComponent from "/container/procurement-dev.jd.net.nz/application/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__